var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.492,
    height: 46.558,
    viewBox: "0 0 63.492 46.558",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(0 -68.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572",
    transform: "translate(0 69.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564",
    transform: "translate(13.049 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M125.506,78.5H106.167a.944.944,0,1,1,0-1.888h19.339a.944.944,0,1,1,0,1.888Z",
    transform: "translate(-105.223 -76.61)",
    fill: "#dedede"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565",
    transform: "translate(3.948 6.919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M42.736,134.289H32.782a.944.944,0,1,1,0-1.888h9.955a.944.944,0,0,1,0,1.888Z",
    transform: "translate(-31.838 -132.401)",
    fill: "#dedede"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    transform: "translate(9.629 13.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M82.526,186.155H78.594a.944.944,0,1,1,0-1.888h3.932a.944.944,0,1,1,0,1.888Z",
    transform: "translate(-77.65 -184.267)",
    fill: "#dedede"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567",
    transform: "translate(0 18.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M10.573,223.716H.944a.944.944,0,0,1,0-1.888h9.629a.944.944,0,0,1,0,1.888Z",
    transform: "translate(0 -221.828)",
    fill: "#dedede"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568",
    transform: "translate(13.049 42.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M126.765,422.056h-20.6a.944.944,0,0,1,0-1.888h20.6a.944.944,0,0,1,0,1.888Z",
    transform: "translate(-105.223 -420.168)",
    fill: "#dedede"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569",
    transform: "translate(3.948 35.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M42.736,366.265H32.782a.944.944,0,0,1,0-1.888h9.955a.944.944,0,0,1,0,1.888Z",
    transform: "translate(-31.838 -364.377)",
    fill: "#dedede"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570",
    transform: "translate(9.629 29.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M82.526,314.4H78.594a.944.944,0,0,1,0-1.888h3.932a.944.944,0,0,1,0,1.888Z",
    transform: "translate(-77.65 -312.511)",
    fill: "#dedede"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571",
    transform: "translate(0 24.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M10.573,276.839H.944a.944.944,0,0,1,0-1.888h9.629a.944.944,0,0,1,0,1.888Z",
    transform: "translate(0 -274.951)",
    fill: "#dedede"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 23.279,
    cy: 23.279,
    r: 23.279,
    transform: "translate(16.934 68.279)",
    fill: "#cf3030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M311.906,68.279q-.884,0-1.751.065a23.28,23.28,0,0,1,0,46.427q.867.065,1.751.065a23.279,23.279,0,1,0,0-46.558Z",
    transform: "translate(-271.692)",
    fill: "#970000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 17.875,
    cy: 17.875,
    r: 17.875,
    transform: "translate(22.338 73.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M312.883,111.855c-.544,0-1.082.026-1.613.073a17.875,17.875,0,0,1,0,35.6c.531.047,1.069.073,1.613.073a17.875,17.875,0,0,0,0-35.75Z",
    transform: "translate(-272.67 -38.172)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581",
    transform: "translate(25.537 76.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573",
    transform: "translate(13.733 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M317.611,140.977a.944.944,0,0,1-.944-.944v-1.441a.944.944,0,0,1,1.888,0v1.441A.944.944,0,0,1,317.611,140.977Z",
    transform: "translate(-316.667 -137.649)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574",
    transform: "translate(22.424 4.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M387.7,172.99a.944.944,0,0,1-.668-1.611l1.019-1.019a.944.944,0,0,1,1.335,1.335l-1.019,1.019A.941.941,0,0,1,387.7,172.99Z",
    transform: "translate(-386.756 -170.084)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575",
    transform: "translate(26.024 13.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M418.174,250.277h-1.441a.944.944,0,1,1,0-1.888h1.441a.944.944,0,1,1,0,1.888Z",
    transform: "translate(-415.789 -248.389)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576",
    transform: "translate(22.424 22.424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M388.719,321.385a.942.942,0,0,1-.667-.276l-1.019-1.019a.944.944,0,1,1,1.335-1.335l1.019,1.019a.944.944,0,0,1-.667,1.611Z",
    transform: "translate(-386.756 -318.479)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    transform: "translate(13.733 26.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M317.611,350.839a.944.944,0,0,1-.944-.944v-1.441a.944.944,0,0,1,1.888,0V349.9A.944.944,0,0,1,317.611,350.839Z",
    transform: "translate(-316.667 -347.511)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578",
    transform: "translate(4.022 22.424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M239.306,321.385a.944.944,0,0,1-.667-1.611l1.019-1.019a.944.944,0,0,1,1.335,1.335l-1.019,1.019A.941.941,0,0,1,239.306,321.385Z",
    transform: "translate(-238.362 -318.479)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    transform: "translate(0 13.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M208.313,250.277h-1.441a.944.944,0,0,1,0-1.888h1.441a.944.944,0,0,1,0,1.888Z",
    transform: "translate(-205.928 -248.389)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580",
    transform: "translate(4.022 4.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M240.325,172.99a.941.941,0,0,1-.667-.276l-1.019-1.019a.944.944,0,1,1,1.335-1.335l1.019,1.019a.944.944,0,0,1-.667,1.611Z",
    transform: "translate(-238.362 -170.084)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582",
    transform: "translate(39.269 82.662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M321.743,194.106h-4.132a.944.944,0,0,1-.944-.944V185.21a.944.944,0,0,1,1.888,0v7.008h3.188a.944.944,0,1,1,0,1.888Z",
    transform: "translate(-316.667 -184.266)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.b17dfe1b7bedc543944e6094ddaa9999.svg";
export { ForwardRef as ReactComponent };